import React, { createContext, useState, useEffect } from 'react';
import { getUserDetails } from '../services/authservices';
import authService from "../services/authservices";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({
    tfaStatus: 0,
    email: null,
    uid: null,
    referralCode: null,
    referralUrl: null,
    displayname: null,
    country: null,
    isAuthenticated: false,
  });
  const [is2FARequired, setIs2FARequired] = useState(false);

  const savedTheme = localStorage.getItem("theme");

  const [theme, setTheme] = useState(savedTheme || "dark");

  useEffect(() => {
    // If we have a theme, persist it on reload
    localStorage.setItem("theme", theme);
    document.body.classList.add(theme); // Add theme to body for global application
  }, [theme]);

  

  const toggleTheme = () => {
    // Toggle the theme between light/dark
    setTheme((prevTheme) => (prevTheme === "dark" ? "light" : "dark"));
  };


  const fetchUserDetails = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const data = await getUserDetails(token);
        if (data && data.status) {
          const userDetails = {
            isAuthenticated: true,
            tfaStatus: data.tfastatus,
            email: data.email,
            displayname: data.displayname,
            country: data.country,
            uid: data.uid,
            referralCode: data.referralCode,
            referralUrl: data.referralUrl,
          };
          const storedApiKey = localStorage.getItem('apiKey');
          const storedSecretKey = localStorage.getItem('secretKey');
          const isUserBound = storedApiKey && storedSecretKey && /^[a-zA-Z0-9]{32,}$/.test(storedApiKey) && /^[a-zA-Z0-9]{32,}$/.test(storedSecretKey);

          if (isUserBound) {
            setUser({ ...userDetails, isBound: true });
          } else {
            setUser({ ...userDetails, isBound: false });
          }
          setIs2FARequired(data.tfastatus === 1);
          return userDetails;
        } else {
          // Default user if not authenticated
          const defaultUser = {
            isAuthenticated: false,
            tfaStatus: 0,
            email: null,
            uid: null,
            referralCode: null,
            referralUrl: null,
            isBound: false,
          };
          setUser(defaultUser);
          setIs2FARequired(false);
          return defaultUser;
        }
      } catch (error) {
        console.error('Error fetching user details:', error);
        setUser({
          isAuthenticated: false,
          tfaStatus: 0,
          email: null,
          uid: null,
          referralCode: null,
          referralUrl: null,
          isBound: false,
        });
        setIs2FARequired(false);
      }
    } else {

      setUser({
        isAuthenticated: false,
        tfaStatus: 0,
        email: null,
        uid: null,
        referralCode: null,
        referralUrl: null,
        isBound: false,
      });
      setIs2FARequired(false);
    }
  };

  const fetchPlanDetails = async () => {
    const token = localStorage.getItem("token");
    try {
      if(token){
        const response = await authService.getPlanDetails(token);
        console.log(response.data,"response.data")
        if (response.data && Array.isArray(response.data)) {
          const freemiumActivated = response.data.some(
            (plan) => plan.subscriptionName === "Freemium" && plan.isFreemiumActivated === true
          );
          localStorage.setItem("freemiumActivated", freemiumActivated);
        }
      }
    } catch (error) {
      console.error("Error fetching plan details:", error);
    }
  };



  const login = async (token) => {
    localStorage.setItem('token', token);
    await fetchUserDetails();
    await fetchPlanDetails();
  };

  useEffect(() => {
    if (localStorage.getItem('token')) {
      fetchUserDetails();
    }
  }, []);

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('freemiumActivated');
    setUser({
      isAuthenticated: false,
      email: null,
      uid: null,
      referralCode: null,
      referralUrl: null,
      displayname: null,
      country: null,
    });
    setIs2FARequired(false);
  }; 

  return (
    <UserContext.Provider value={{ user, setUser, login, logout, is2FARequired,theme, toggleTheme}}>
      {children}
    </UserContext.Provider>
  );
};   